import { render, staticRenderFns } from "./appMessages.vue?vue&type=template&id=08f41a53&"
import script from "./appMessages.vue?vue&type=script&lang=js&"
export * from "./appMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports